<template>
    <div>
      <div class="d-flex align-items-center mb-1">
        <b-avatar
          rounded
          size="32"
          variant="light-danger"
          class="mr-75 rpIcon"
        >
          Rp
        </b-avatar>
        <div>
          <h4 class="mb-0 page-title">
            Tarif
          </h4>
          <b-link @click="detail()" class="title"><feather-icon
            icon="ArrowLeftIcon"
            size="16"
            style="margin-bottom:0.3rem;"
          />{{title}}</b-link>
        </div>
      </div>
      <b-card v-if="isLoading">
        <b-card-text class="pl-5">
          <SkeletonContainer />
        </b-card-text>
      </b-card>
      <b-card v-else-if="(tarifStatus === true)" class="text-center no-data">
        <b-card-text>
          <h4 class="text-muted text-center">
            {{ tarifHiddenMessage }}
          </h4>
        </b-card-text>
      </b-card>

      <b-card v-else-if="!tarif || tarif == '' || tarif.length < 10" class="text-center no-data" title="Mengacu kepada kebijakan masing-masing CFU">
      </b-card>
      <b-card v-else>
        <b-card-text>
          <b-row>
                <b-col md="12" class="mb-2 pl-5">
                  <div class="d-flex justify-content-start align-items-center mb-75">
                      <div class="blog-category-title txt-dark font-weight-light" v-html="tarif" />
                  </div>
                </b-col>
              </b-row>

        </b-card-text>
      </b-card>
      
      <b-row v-if="tarifStatus === false">
        <b-col>
          <b-card title="Document">
            <b-tab
              active
              title="Left"
            >
              <b-tabs
                vertical
                nav-wrapper-class="nav-vertical"
                class="pl-0"
              >
                <b-tab active>
                  <template #title>
                    <span><feather-icon size="16" icon="FileTextIcon" /> References Document</span>
                  </template>

                  <b-card-text 
                    class="border border-danger font-weight-bolder rounded p-1 bold"
                    v-for="(data, index) in tarifFile"
                    :key="index"
                  >
                    <b-row>
                      <b-col class="txt-xs-2" sm="6">
                        <span><feather-icon size="16" icon="FileTextIcon" /> {{ data.usrName }} </span>
                      </b-col>
                      <b-col class="txt-xs-2 font-weight-lighter" sm="6">
                        <span class="mr-3">
                          {{toMB(data.size)}} MB
                        </span>
                        <span>
                          {{ data.created_at ? data.created_at : '1 Jan 2021' }}
                        </span>
                        <span>
                          <b-button class="txt-xs-2 float-right" size="sm" variant="primary" @click="openDocument(index)">
                            <span><feather-icon size="14" icon="DownloadIcon" /> Download </span>
                          </b-button>
                        </span>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-tab>
              </b-tabs>
            </b-tab>
          </b-card>
        </b-col>
        <b-modal
            ref="modal-request-access"
            centered
            title="Vertically Centered"
            :hide-footer="true"
            :hide-header="true"
            size="md"
          >
          <div class="d-flex flex-column align-items-center">
            <div class="align-self-end"> 
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-secondary"
                class="btn-icon"
                size="md"
                @click="$refs['modal-request-access'].hide()"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </div>
            <div class="h2 text-danger mb-2">
              Kamu Tidak Mempunyai Hak Akses!
            </div>
          </div>
        </b-modal>
      </b-row>
    </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import {
  BCard, BCardText,BLink,BAvatar,BRow,BCol,BTabs, BTab, BButton, BModal,
} from 'bootstrap-vue'
import { timeout } from 'q'
import SkeletonContainer from './components/SkeletonContainer.vue'
import { generateToken } from '@/auth/helperAuth'

export default {
  components: {
    BButton,
    BTabs, 
    BTab,
    BRow,
    BCol,
    BCard,
    BAvatar,
    BLink,
    BModal,
    AppCollapse,
    AppCollapseItem,
    BCardText,
    SkeletonContainer,
  },
  data() {
    return {
      token: '',
      tarif: null,
      tarifFile: [],
      title: '',
      isLoading: false,
      tarifHiddenMessage: "",
      tarifStatus: null,
    }
  },
  computed: {
    canTarif() {
      let permissions = this.$store.getters['oauth/getActiveUser'].permissions
      if (!permissions.includes('calculator_tarif')) {
        return false
      }
      return true
    },
    isAdminOrApprover() {
      let roles = this.$store.getters['oauth/getActiveUser'].role
      if (roles.includes('approver') || roles.includes('admin')) {
        return true
      }
      return false
    }
  },

  mounted(){
    const mapRequest = {
      map: {
        PRODUCT: 'd',
        PROD_CATEGORY: 's',
        PROD_TARIFF: 'd',
        tarifFileLink: 'd'
      }
    }
    this.isLoading = true
    this.$http.post('/product/browse/id/'+this.$route.params.key+'/set/first/published/true', mapRequest).then(response => { 
      this.$store.commit('app/SET_PAGE_TITLE',response.data.data.records.PRODUCT)
      this.title = response.data.data.records.PRODUCT
      if(response.data.data.records.PROD_CATEGORY !== "3"){
        this.tarif = response.data.data.records.PROD_TARIFF
        this.tarifFile = response.data.data.records.tarifFileLink
      }else if(this.isAdminOrApprover){
        this.tarif = response.data.data.records.PROD_TARIFF
        this.tarifFile = response.data.data.records.tarifFileLink
      }
    })
    .finally(() => {
      this.isLoading = false
    })
    this.fetchTarifStatus()
  },
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
    };
    this.token = generateToken(payload)
  },
  methods: {
    async fetchTarifStatus() {
      try {
        const response = await fetch(`${process.env.VUE_APP_API_HELPER_URL}/product/tarif/hidden?product_kode=`+this.$route.params.key, {
          headers: {'Client-Device': 'browser', 'Authorization': `${this.token}`}
        });
        
        const result = await response.json();
        this.tarifStatus = result.data.is_hidden
        this.tarifHiddenMessage = result.data.description
        console.log(this.tarifStatus)
      } catch (error) {
        console.error('Error to get status tarif:', error);
      } finally {
        // this.isLoading = false;
      }
    },
    showModalNeedAccess() {
      this.$refs['modal-request-access'].show()
    },
    toMB(bytes) {
      let mb = bytes * 0.000001
      return mb.toFixed(2)
    },
    detail(){
      const routeName = this.$route?.name || ''
      const rootText = this.$route?.meta?.breadcrumb?.[0]?.text || ''
      if (routeName.includes('bundling') || rootText === 'Product Bundling') {
        this.$router.push({name : 'product-bundling-detail', params:{key:this.$route.params.key}})
      } else if(this.$route.meta.breadcrumb[1].text == 'Communication'){
        this.$router.push({name : 'product-communication-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Datacomm'){
        this.$router.push({name : 'product-datacomm-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Internet'){
        this.$router.push({name : 'product-internet-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Wireless'){
        this.$router.push({name : 'product-wireless-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'CONS'){
        this.$router.push({name : 'product-cfu-cons-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'EBIS'){
        this.$router.push({name : 'product-cfu-ebis-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'WIBS'){
        this.$router.push({name : 'product-cfu-wibs-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Segmentation'){
        this.$router.push({name : 'product-segmentation-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Targeting'){
        this.$router.push({name : 'product-targeting-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Cyber Security'){
        this.$router.push({name : 'product-cyber-security-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Fitur'){
        this.$router.push({name : 'product-fitur-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Produk'){
        this.$router.push({name : 'product-produk-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Varian'){
        this.$router.push({name : 'product-varian-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'DTP'){
        this.$router.push({name : 'product-dtp-detail', params:{key:this.$route.params.key}})
      }
    },
    openDocument(index) {
      const mapRequest = {
        map: {
          tarifFileLink: 'd'
        }
      }
      this.$http.post('/product/browse/id/'+this.$route.params.key+'/set/first/published/true', mapRequest).then(response => { 
        const tarifFile = response.data.data.records.tarifFileLink
        window.open(tarifFile[index].link, '_blank')
      })
    }
  }
}
</script>

<style>
.b-avatar.badge-light-danger {
  background-color: red;
  color: white
}

.title {
  color:black;
}

.no-data > .card-body{
  padding:1rem !important;
}

.no-data > .card-body > .card-title{
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 1.2em;
  color: gray;
}

@media (max-width: 767px) {
  .page-title {
    font-size: 1.4rem;
  }
}
</style>
